/**
 * functions
 */
import { updateLazy } from "Functions/lazy";
import { initTippy } from "Functions/tippy";
import smoothscroll from "smoothscroll-polyfill";

/**
 * common & components
 */
import "Common/validate-defaults";
import "Common/eshop";
import "Common/window";
import "Common/info-messages";
import "Common/form-addons";
import "Common/toggle-password";

import "Common/product-cart-quantity";
import "Common/spinner-quick-update";

import "Components/modal/modal-back";
import "Components/modal/modal-jump";
import "Components/modal/modal-open-from-hash";
import "Components/presents";

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.Event.dispatch("Custom.Cart.addedItem", { form, response });
};
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.Event.dispatch("Custom.Cart.updatedItem", { input, response });
};
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.Event.dispatch("Custom.Cart.removedItem", { form, response });
};

window.updateLazy = updateLazy();

document.addEventListener("DOMContentLoaded", () => {
    updateLazy();
    initTippy();
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-back").forEach((back) => {
        back.addEventListener("click", (event) => {
            if (event.currentTarget.getAttribute("href") == "#") {
                event.preventDefault();

                window.history.back();
            }
        });
    });
});

smoothscroll.polyfill();

/**
 * Trodat Gifts Handlers
 */
document.addEventListener('DOMContentLoaded', () => {
    // Handle trodat gift selection
    $(document).on('click', '.js-trodat-gift-select', function(e) {
        e.stopPropagation();
        const productId = $(this).data('product-id');
        const variationId = $(this).data('variation-id') || null;

        const data = {
            product_id: productId
        };

        if (variationId) {
            data.product_variation_id = variationId;
        }

        $.ajax({
            url: '/cart/add-trodat-gift',
            method: 'POST',
            data: data,
            dataType: 'json'
        }).always(() => {
            location.reload();
        });
    });

    // Handle trodat gift removal
    $(document).on('click', '.js-trodat-gift-remove', function(e) {
        e.stopPropagation();
        $.ajax({
            url: '/cart/remove-trodat-gift',
            method: 'POST',
            dataType: 'json'
        }).always(() => {
            location.reload();
        });
    });
});


